export default __webpack_public_path__ + "static/media/down-arrow.eb87235b.svg";